module.exports = __webpack_public_path__ + "img/SC-PROOF-6799.863b3a3c.png";